/**
 * Created by Slava on 05.09.2024
 */

cleverapps.reloadSnapshotScene = function (scene, f) {
    if (scene.villagePlayer && scene.villageState !== Village.STATE_BUILD) {
        const player = scene.villagePlayer;
        cleverapps.villagePlayers.addPlayer(player);

        const village = new Village(player.villageLevel, { player, data: scene.village });
        const prefab = village.isStateRaid() ? bundles.main.jsons.villageraidscene_prefab_json : bundles.main.jsons.villageattackscene_prefab_json;

        cleverapps.scenes.replaceScene(Prefab.instantiate(prefab, { args: { village, snapshotLoaded: true } }), f);
        return;
    }

    if (scene.episodeNo !== undefined) {
        CoinKingdom.OpenSlotMachine(f);
        return;
    }

    cleverapps.meta.gotoMainLocation(f);
};
